<cache-date></cache-date>

<br><br>


<div class="form-group">
	<ng-container *ngFor="let dateType of filter.filterParams.dateFilterParams | keys">
		{{ 'adminstat.filterForm.' + dateType | translate }}
		<select class="form-control" [(ngModel)]="filter.filterParams.dateFilterParams[dateType].type" [ngModelOptions]="{standalone: true}" [sextant]="'filter-dateType.' + dateType">
			<option *ngFor="let opt of ['all', 'now', 'yesterday', 'prevWeek', 'prevMonth', 'last7day', 'last30day', 'other']"
					value="{{ opt }}" [selected]="opt == filter.filterParams.dateFilterParams[dateType].type">{{ 'adminstat.common.interval.' + opt | translate }}
			</option>
		</select>
		<table>
			<tr [style.display]="filter.filterParams.dateFilterParams[dateType].type != 'other' ? 'none' : null">
				<td>
					<datepicker [(ngModel)]="filter.filterParams.dateFilterParams[dateType].start" [ngModelOptions]="{standalone: true}" [format]="'DD-MM-YYYY'"></datepicker>
					<datepicker [(ngModel)]="filter.filterParams.dateFilterParams[dateType].end" [ngModelOptions]="{standalone: true}" [format]="'DD-MM-YYYY'"></datepicker>
				</td>
			</tr>
		</table>
	</ng-container>
	
	{{ 'adminstat.mails.mailer.site filter' | translate }}
	<input class="form-control" [(ngModel)]="filter.filterParams.siteUrl" [ngModelOptions]="{standalone: true}">

	<br><br>

	<button type="button" class="btn btn-success" (click)="applyFilters()" [sextant]="'btnApplyFilters'">{{ 'adminstat.common.Apply' | translate }}</button>
	<button type="button" class="btn btn-link" style="color:red;" (click)="resetFilters()">{{ 'adminstat.common.Reset filters' | translate }}</button>
</div>

<br>


<div class="col-md-12">
	<chart
		[data]="chart.data"
		[options]="chart.options"
		[sextant]="'chart'" [url]="filter.currentUrl"
	></chart>
</div>

<br>

<loading [isLoad]="paginationLoader"></loading>
<ngb-pagination
	*ngIf="pagination.pageCount > 0"
	[collectionSize]="pagination.pageCount"
	[maxSize]="10"
	[pageSize]="1"
	[(page)]="pagination.page"
	[boundaryLinks]="true"
	(pageChange)="onPageChange()"
	[sextant]="'pagination'"
	[url]="filter.currentUrl"
></ngb-pagination>

<br>

<ngb-accordion #acc="ngbAccordion">
	<ngb-panel title="{{ 'adminstat.common.description' | translate }}">
		<ng-template ngbPanelContent>
			Хит - просмотр страницу<br/>
			Хост - ip-пользователя<br/>
			Уник - user agent-пользователя
		</ng-template>
	</ngb-panel>
</ngb-accordion>

<br>

<loading [isLoad]="statsLoader"></loading>
<div class="col-md-12" *ngIf="stats && stats.length > 0">
	<table class="table" [sextant]="'stats'" [url]="filter.currentUrl">
		<thead>
			<tr>
				<th></th>
				<th>{{ 'adminstat.common.site address' | translate }}</th>
				<th>{{ 'adminstat.site.site_top.hitCount' | translate }}</th>
				<th>{{ 'adminstat.site.site_top.hostCount' | translate }}</th>
				<th>{{ 'adminstat.site.site_top.uniqueCount' | translate }}</th>
			</tr>
		</thead>
		
		<tbody>
			<tr *ngFor="let stat of stats">
				<td>
					<div style="float: left;margin-right: 5px;">
						<button type="button" class="btn btn-default" aria-label="Left Align" (click)="showDetails(stat.host)">
							<i class="fa fa-chart-line" aria-hidden="true"></i>
						</button>
					</div>
				</td>
				
				<td>
					<site_info [siteUrl]="stat.host"></site_info>
				</td>
				
				<td>
					{{ stat.hitCount || 0 | prettyNumber}}
				</td>
	
				<td>
					{{ stat.hostCount || 0 | prettyNumber}}
				</td>
	
				<td>
					{{ stat.uniqCount || 0 | prettyNumber}}
				</td>
			</tr>
		</tbody>
	</table>
</div>
